import { Howl } from "howler";

import src from "../../sounds/tock.wav";

export const tock = new Howl({
  src: [src]
});
